import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageService} from './storage.service';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {AuthUser} from '../models/auth-user.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {RefreshToken} from '../models/refresh-token.interface';

const API = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  readonly $onLogin: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private http: HttpClient, private storageService: StorageService) {
  }

  login(email: string, password: string, cognitoJWT?: string): Observable<ApiHttpResponse<AuthUser>> {
    const body = {email, password, cognitoJWT};
    return this.http.post<ApiHttpResponse<AuthUser>>(`${API}login`, body)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<AuthUser>) => {
            this.storageService.saveUserAuth(res.content);
            return res;
          }
        ));
  }

  refreshToken(): Observable<ApiHttpResponse<RefreshToken>> {
    const user = this.storageService.getUser();
    const body = {userId: user.userId, refreshToken: user.refreshToken};
    return this.http.post<ApiHttpResponse<RefreshToken>>(`${API}refresh-token`, body)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<RefreshToken>) => {
            this.storageService.updateToken(res.content.token, res.content.refreshToken);
            return res;
          }
        ));
  }

  logout(): void {
    this.storageService.clearInfo();
  }

  isLoggedIn(): boolean {
    return this.storageService.userExists();
  }

  getUsername(): string {
    return this.storageService.getUser().username;
  }

  getSystem(): string {
    return this.storageService.getUser().system;
  }

  getCountry(): string {
    return this.storageService.getUser().country;
  }

  getEmail(): string {
    return this.storageService.getUser().email;
  }

  userHasAnyRole(roles: string[]): boolean {
    if (!roles) {
      return true;
    }
    let userHasRole = false;
    const user = this.storageService.getUser();
    roles.forEach(role => {
      if (user.roles && user.roles.includes(role)) {
        userHasRole = true;
      }
    });
    return userHasRole;
  }

  getUserRoles(): string[] {
    return this.storageService.getUser().roles;
  }

}
